import { ASSETS_BASE_URL } from "../../config";

export const openComplianceDocument = ({ document, fallbackUrl, onShowDescription }) => {
	if (document?.external_url) {
		window.open(document.external_url, "_blank", "noopener,noreferrer");
		return true;
	}

	if (document?.file_path) {
		const url = `${ASSETS_BASE_URL}/${document.file_path}`;
		window.open(url, "_blank", "noopener,noreferrer");
		return true;
	}

	if ((document?.description_html || document?.description_text) && onShowDescription) {
		onShowDescription(document);
		return true;
	}

	if (fallbackUrl) {
		window.open(fallbackUrl, "_blank", "noopener,noreferrer");
		return true;
	}

	return false;
};
